import Form from '../Form';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import withGlobalContent from '../../hocs/withGlobalContent';
import * as subscriptionsFacade from '../../../facades/eagle/subscriptions';

const enhance = compose(
  withGlobalContent,
  mapProps(props => ({
    primary: {
      title: props.primary.title,
      formId: 'sign-up-newsletter',
      formError: props.globalContent.error.email.invalid,
      formSuccess: props.globalContent.success.newsletter,
      onSubmit: subscriptionsFacade.newsletter,
    },
    items: [
      {
        inputType: 'email',
        inputId: 'email',
        inputName: 'email',
        inputPlaceholder: props.primary.emailLabel,
        required: true,
        errorMessage: props.primary.invalidEmail,
      },
      {
        inputType: 'submit',
        inputId: 'submit',
        inputName: 'submit',
        label: props.primary.submitLabel,
      },
    ],
  }))
);

export default enhance(Form);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Newsletter/index.js